import type { ComponentSchema } from '../../../../../schema-types'

/** Tint band with the title and count, the saved products as theme cards, or an empty state. */
export const schema: ComponentSchema = {
  type: 'wishlist',
  label: 'Wishlist',
  description: 'The products a shopper saved, or an empty state with a link back to the shop.',
  supportedPages: ['wishlist'],
  variants: [{ id: 'v1', label: 'Saved products' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Wishlist' },
    { key: 'subtitle', label: 'Subtitle', type: 'string' },
    { key: 'emptyTitle', label: 'Empty title', type: 'string', default: 'Your wishlist is empty' },
    { key: 'emptyText', label: 'Empty message', type: 'string' },
    { key: 'continueShoppingText', label: 'Continue shopping text', type: 'string', default: 'Continue shopping' },
    { key: 'continueShoppingLink', label: 'Continue shopping link', type: 'string', default: '/shop' },
  ],
}
